
const state = {
  mouseup: undefined,
  keypress: undefined,
}
const getters = {
  mouseup: state => {
    return state.mouseup
  },
  keypress: state => {
    return state.keypress
  }
}
const actions = {
  mouseupEvent({ commit }, { event }) {
    commit("MOUSEUP_EVENT", { event })
  },
  keypressEvent({ commit }, { event }) {
    commit("KEYPRESS_EVENT", { event })
  },
}
const mutations = {
  MOUSEUP_EVENT(state, { event }) {
    state.mouseup = event
  },
  KEYPRESS_EVENT(state, { event }) {
    state.keypress = event
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};